import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import * as XLSX from 'xlsx';
import { URL } from "../../config";

const RegisterMulti = () => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const history = useHistory();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!file) {
      setError("Por favor, selecione um arquivo.");
      return;
    }
    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
    
      let allUsers = [];
    
      workbook.SheetNames.forEach((sheetName) => {
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        allUsers = allUsers.concat(jsonData);
      });
    
      try {
        const response = await fetch(`${URL}/webland-api/user/register-multiple`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ users: allUsers }),

        });
        
        const data = await response.json();
        
        if (response.status === 207) {
          const errors = data.results.filter(r => !r.success);
          if (errors.length > 0) {
            const errorList = errors.map(err => `${err.email}: ${err.error}`).join("\n");
            setError(`Alguns registos falharam:\n${errorList}`);
          } else {
            history.push("/registration-success");
          }
        } else if (!response.ok) {
          setError(data.message);
        }
      } catch (error) {
        console.error("Error during registration:", error);
        setError("O registro falhou. Por favor, tente novamente mais tarde.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="upload-users-container">
      <h2>Adicionar múltiplos utilizadores por Excel </h2> 
       
      
      <div className="form-group">
        <label htmlFor="file">Selecione o arquivo Excel: (
            <a href="/user_roles_template.xlsx" download>
          Exemplo excel)
        </a></label>
        <input
          type="file"
          id="file"
          accept=".xlsx"
          onChange={handleFileChange}
        />
      </div>
      <button
        type="button"
        className="default-button"
        onClick={handleFileUpload}
      >
        Upload Excel
      </button>
      {error && <div className="error-message">{error}</div>}
      
    </div>
  );
};

export default RegisterMulti;